import { render, staticRenderFns } from "./ActionsBar.vue?vue&type=template&id=86f4a23a&"
import script from "./ActionsBar.vue?vue&type=script&lang=js&"
export * from "./ActionsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86f4a23a')) {
      api.createRecord('86f4a23a', component.options)
    } else {
      api.reload('86f4a23a', component.options)
    }
    module.hot.accept("./ActionsBar.vue?vue&type=template&id=86f4a23a&", function () {
      api.rerender('86f4a23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/ActionsBar.vue"
export default component.exports